// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min
}

let endTimeG

function cutDownTime() {
  let nowTime = new Date()
  let endTime = new Date(endTimeG)

  let leftTime = endTime.getTime() - nowTime.getTime()
  if (leftTime < 0) {
    setupNewCountdown()
    leftTime = 0
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60)
  leftH = leftH >= 10 ? leftH : '0' + leftH
  leftM = leftM >= 10 ? leftM : '0' + leftM
  leftS = leftS >= 10 ? leftS : '0' + leftS

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  }
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9)
  const currentTime = new Date()
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
}
let intervalId

function getCutDownTime() {
  setupNewCountdown()
  if (intervalId) clearInterval(intervalId)
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime()
    $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
    $('.sp_top_cut_down .sp_left_view .sp_minute').html(cutDownTimeText.minute)
    $('.sp_top_cut_down .sp_left_view .sp_second').html(cutDownTimeText.second)
  }, 1000)
}

getCutDownTime()

jQuery('#nav0').slide({
  mainCell: '.nav-imgs',
  autoPlay: true,
  effect: 'leftMarquee',
  interTime: 8,
  vis: 2,
  scroll: 2,
})

// new Swiper("#swiper-btn", {
//   autoplay: true,
//   autoplay: {
//     disableOnInteraction: false,
//     // delay: 5000,
//   },
//   loop: true,
//   spaceBetween: 30,
// });

function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
  })

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    preloadImages(spImgList)
    preloadImages(imgArr)
    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            246 * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }

  let prods = window.product
  console.log(window.options)
  function getCur() {
    let color = $('#color div.active').attr('data-val')
    let size = $('#Size div.active').attr('data-val')
    return prods.filter(
      item => item.option1 == color && item.option2 == size
    )[0]
  }
  function changePrice() {
    let num = $('#calcNumber').val()
    let price = ((getCur().price * num) / 100).toFixed(2)
    let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
    // if(num == 1){
    //   price = (getCur().price * num / 100).toFixed(2)
    // }else if(num == 2){
    //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
    // }else if(num == 3){
    //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
    // }else {
    //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
    // }
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('.product-part .price-group .price1 span').html(price)
    $('.product-part .price-group .price2 span').html(compare)
    let off_font =
      100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
    $('.product-part .price-group .sp-row span').html(off_font)
  }

  $('.reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
      changePrice()
    }
  })
  $('.add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice()
  })

  let spImgList = [
    [
      'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/mascara1.png',
      'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/mascara4.png',
      'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/mascara3.png',
    ],
    [
      'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/mascara2.png',
      'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/mascara5.png',
      'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/mascara6.png',
    ],
  ]
  var imgArr = [
    'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/free_6.png?v=1734935509',
    'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/free_8.png?v=1734935579',
    // 'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/2_3_eb909227-2990-419f-9889-223487e0569f.png?v=1734935319',
    
    'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/free_8.png?v=1734935579',
    'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/free_5.png?v=1734935545',
    'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/2_3_81ec8e69-4b40-4562-8b45-648fdf612701.png?v=1734935319',

    // "https://cdn.shopify.com/s/files/1/0742/6621/4642/files/2_3_8b652c64-0790-44f5-8a7b-7367287d7529.png?v=1734935319",
    'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/3_5_bb623fd8-7b2b-41f8-8380-d103d52cfd7f.png?v=1734935319',
    'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/3_5.png?v=1734935319',
    'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/3_5_92a36d55-c9b3-4e01-94e5-b017e3d11da9.png?v=1734935319',
    // "https://cdn.shopify.com/s/files/1/0742/6621/4642/files/3_5_5d69adee-6abb-4787-9b2e-c5c4d3a9e3ac.png?v=1734935319",
    // "https://cdn.shopify.com/s/files/1/0742/6621/4642/files/2_6.png?v=1734935319",
    'https://cdn.shopify.com/s/files/1/0742/6621/4642/files/6_2.png?v=1734935319',
  ]
  // $('#Size .option').click(function () {
  //   let index = $(this).index()

  //   $('.product-part .swiper-box>img').attr('src', imgArr[index + 2])
  // })
  // $('#color .option').click(function () {
  //   let index = $(this).index()

  //   $('.product-part .swiper-box>img').attr('src', imgArr[index])
  // })
  $('.option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    changePrice()
    let color = $('#color div.active').index();
    let size = $('#Size div.active').index();
    if (color == 0) {
      if (size == 0){
         $('.product-part .swiper-box>img').attr('src', imgArr[0])
      }else {
           $('.product-part .swiper-box>img').attr('src', imgArr[1])
      }
     
    }else {
      if (size == 0){
         $('.product-part .swiper-box>img').attr('src', imgArr[2])
      }else {
           $('.product-part .swiper-box>img').attr('src', imgArr[3])
      }
    }
    
  })



  $('.cart-btn').click(function () {
    $(this).children('img').addClass('on')
    setTimeout(function () {
      $('.cart-btn').children('img').removeClass('on')
      $('.sp-header-top .sp-cart').removeClass('on')
    }, 500)
    $('.sp-header-top .sp-cart').addClass('on')
  })

  $('.product-part .cart-btn').click(function () {
    $('.c_toast').show()
    setTimeout(function () {
      $('.c_toast').hide()
    }, 1200)

    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          $('#cardNum').html(result.item_count)
          handleAddToCart(result.item_count)
          $('#calcNumber').val(1)
        })
      },
      dataType: 'json',
    })

    var img = $('.product-part .swiper-box img')
    var flyer = img[0].cloneNode(true)
    flyer.classList.add('sp_clone')

    $('.product-part').append(flyer)
    $('.sp_clone').css({
      width: img[0].width,
      height: img[0].height,
      position: 'fixed',
      top: 0,
      left: img.offset().left,
      'z-index': '99',
    })

    let finish = $('.sp-cart')
    $('.sp_clone').animate(
      {
        top: finish[0].offsetTop + $('.time-part').height(),
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
        'z-index': '99',
      },
      500,
      'linear',
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $('.sp-header-top .sp-cart').addClass('sp-shake')
            setTimeout(function () {
              $('.sp-header-top .sp-cart').removeClass('sp-shake')
            }, 400)
            $(this).detach()
          }
        )
      }
    )
  })

  $('.buyNow').click(function () {
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })
}

mainRender()
